<template>
  <div>
    <el-dialog :title="lookTitle" :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan" @close="closeDialog" :visible="lookImgMark" width="500px" center>
      <div style="width: 260px; height: 300px;margin:20px auto;">
        <el-form :inline="true" :model="lookFrom" ref="lookFrom" class="demo-form-inline" size="mini">
          <el-form-item v-if="lookImgMark">
            <span v-if="isFK">
              <el-image :src="lookFrom.fileKeyUrl" style="width: 260px; height: 200px;"
                :preview-src-list="[lookFrom.fileKeyUrl]">
              </el-image>
            </span>
            <span v-else>
              <el-upload disabled action="" multiple :file-list="lookFrom.contractFileList"
              :on-preview="handlePictureCardPreview"></el-upload>
            </span>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {getFileShow } from '@/api/newTMS'
import uploadImgs from '@/components/uploadImgs.vue'
export default{
  components: {
    uploadImgs,
  },
  props: {
    lookImgMark: {
      type: Boolean,
      default: false
    },
    lookImgData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isFK: {
      type: Boolean,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      lookTitle:'查看凭证',
      lookFrom:{
        contractFileList:[]
      }
    }
  },
  mounted () {
    if(this.isFK){
      this.getFileShow(this.lookImgData,'settlementRecordMaster',true)
    }else{
      this.getFileShow(this.lookImgData,'invoiceRecordMaster',true)
    }
  },
  methods: {
    closeDialog(){
      this.$emit('update:lookImgMark', false)
      this.lookFrom= {}
    },
    getFileShow(params,businessType,isLook){
      // businessId ※必传 对应业务类型主表id
	    // businessType ※必传 业务类型 订单：order；客户承运商：customer；合同：contract
      getFileShow({
        businessId:params.id,
        businessType:businessType
      }).then(res => {
        // console.log(res,'营业执照')
        if(businessType == 'settlementRecordMaster'){//收付款凭证
          // 查看文件
          if(isLook){
            if(res.length!=0){
              this.lookFrom = res[0]
            }else{
              this.$message({
                message: '暂无文件照片',
                type: 'error'
              })
            }
          }
        }else{
          if(res.length!=0){
            res.forEach((item, index) => {
              // console.log(item)
              let name = item.url.substring(item.url.lastIndexOf('/') + 1)
              this.$set(this.lookFrom.contractFileList, index, { status: 'ready', name: name, url: item.fileKeyUrl, id: item.fileId })
            })
          }else{
            this.$message({
              message: '暂无文件照片',
              type: 'error'
            })
          }
        }
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    handlePictureCardPreview (file) {
      window.open(file.url) // 重新打开一个浏览器页进行预览
    }
  }
}
</script>
<style lang="scss" scoped>
</style>